class openVacancies extends HTMLElement {
  connectedCallback() {
    this.loader = this.querySelector('[data-table-loader]');
    this.table = this.querySelector('[data-jobs-table]');

    // Show loader
    this.loader.classList.remove('hidden');
    this.loader.classList.add('flex');

    fetch('https://khadi-naturprodukte-gmbh-co-kg-1.jobs.personio.de/xml')
      .then((response) => response.text())
      .then((xmlData) => {
        // Parse XML data
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlData, 'text/xml');

        const jobs = Array.from(xmlDoc.querySelectorAll('position'));
        const jobsHtml = jobs
          .map((job) => {
            const id = job.querySelector('id').textContent;
            const name = job.querySelector('name').textContent;
            const office = job.querySelector('office').textContent;
            const schedule = job.querySelector('schedule').textContent;
            return `
              <tr class="hidden md:table-row">
                <td class="md:border-b border-dark-gray font-bold py-4 text-start text-sm leading-5 lg:text-base lg:leading-6">${name}</td>
                <td class="md:border-b border-dark-gray py-4 text-start text-sm leading-5 lg:text-base lg:leading-6">${office}</td>
                <td class="md:border-b border-dark-gray py-4 text-start text-sm leading-5 lg:text-base lg:leading-6">${schedule}</td>
                <td class="md:border-b border-dark-gray py-4 text-start">
                  <a class="button button--link text-xs leading-4" href="https://khadi-naturprodukte-gmbh-co-kg-1.jobs.personio.de/job/${id}" target="_blank">Job Details</a>
                </td>
              </tr>
              <div class="flex flex-col gap-2 md:hidden mb-6 last:mb-0">
                <p class="md:border-b border-dark-gray font-bold text-sm leading-5 text-start">${name}</p>
                <div class="flex items-center gap-4">
                  <p class="md:border-b border-dark-gray text-sm leading-5 text-start">${office}</p>
                  <p class="md:border-b border-dark-gray text-sm leading-5 text-start">${schedule}</p>
                </div>
                <p class="md:border-b border-dark-gray text-start">
                  <a class="button button--link text-xs leading-4" href="https://khadi-naturprodukte-gmbh-co-kg-1.jobs.personio.de/job/${id}" target="_blank">Job Details</a>
                </p>
              </div>
            `;
          })
          .join('');

        // Display jobs in the HTML
        document.getElementById('jobs-list').innerHTML = jobsHtml;
        // Hide loader
        this.loader.classList.add('hidden');
        // Show table loader
        this.table.classList.remove('hidden');
      })
      .catch((error) => console.error('Error fetching XML:', error));
  }
}

customElements.define('open-vacancies', openVacancies);
